import React from 'react';
import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import "react-datepicker/dist/react-datepicker.css";
import { Loader } from "../../../components/Loader";
import { Card } from "../../../components/Card";
import { Cell, List, Row } from "../../../components/List";
import { getDWHStatus } from "../actions";
import { REQUEST_DWH_STATUS } from "../constants";
import { selectWork } from "../../Api/selectors";
import { selectDWHStatus } from "../selectors";

const Container = styled.div``;

const STATE = {}

/* eslint-disable react/prefer-stateless-function */
class DwhStatusComp extends BaseComponent {
  constructor(props) {
    super(props, STATE);
  }

  componentDidMount() {
    this.props.getDWHStatus();
  }

  get reports() {
    return this.props?.dwhStatus?.reports ?? [];
  }

  renderReportStatus(report) {
    return (
      <Row key={report.id}>
        <Cell>{report.name}</Cell>
        <Cell>{this.formatDate(report.lastDataUpdateAt)}</Cell>
      </Row>
    );
  }

  formatDate(date) {
    if (!date) return 'no data';

    const inputDate = new Date(date);

    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    }).format(inputDate);
  }

  renderReportsSection() {
    if (!this.reports.length) return (
      <p>No data</p>
    );

    return (
      <List>
        {this.reports.map(r => this.renderReportStatus(r))}
      </List>
    );
  }
  render() {
    if (this.props.work) return <Loader small/>;
    console.log('this.props', this.props);
    return (
      <Container>
        <h3>{this.lbl('tools.overview.dwh')}</h3>
        <React.Fragment>
          <Card className="vehicle-info-card info-card data">
            <Container>
              {this.renderReportsSection()}
            </Container>
          </Card>
          </React.Fragment>
      </Container>
    );
  }
}

DwhStatusComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork([REQUEST_DWH_STATUS]),
    dwhStatus: selectDWHStatus(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    getDWHStatus() {
      dispatch(getDWHStatus());
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const DwhStatus = compose(
  withConnect,
  withRouter,
)(DwhStatusComp);
